import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPause: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPause"><Path d="M6.5 3C5.11929 3 4 4.11929 4 5.5V18.5C4 19.8807 5.11929 21 6.5 21H7.5C8.88071 21 10 19.8807 10 18.5V5.5C10 4.11929 8.88071 3 7.5 3H6.5Z" fill="currentColor"/><Path d="M16.5 3C15.1193 3 14 4.11929 14 5.5V18.5C14 19.8807 15.1193 21 16.5 21H17.5C18.8807 21 20 19.8807 20 18.5V5.5C20 4.11929 18.8807 3 17.5 3H16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPause;
